import { History } from "@mui/icons-material";
import { Button, Chip } from "@mui/material";
import { CertificateActions } from "../../CertificateDocs/CertificateActions";
import { DocumentCard } from "../../../../../../components/common/DocumentCard";
import { EhrResponsiveTable } from "../../../mobile/EhrResponsiveTable";
import { useDocumentHistoryColumn } from "./useDocumentHistoryColumn";

/** Data mais recente do documento (pipeline paciente só tem `date`). */
function latestDocDate(row: any): string {
  return row.lastDate || row.date || row.firstDate || "—";
}

export function NoteReport({
  rowData = [],
  handleOpen,
  setBinaryUrl,
  sign,
  setRefetch,
  /** Visão paciente: só "Emitido em" (data mais recente), sem Última reemissão / Histórico. */
  patientView = false,
}: any) {
  const { displayRows, historyDialog, openHistory, rowHasHistory } =
    useDocumentHistoryColumn({
      rowData,
      handleOpen,
      setBinaryUrl,
    });

  const columns = patientView
    ? [
        { column: "Profissional", rowName: "practitioner" },
        { column: "Emitido em", rowName: "firstDate" },
        { column: "Especialidade", rowName: "specialty" },
      ]
    : [
        { column: "Profissional", rowName: "practitioner" },
        { column: "Emitido em", rowName: "firstDate" },
        { column: "Última reemissão", rowName: "lastDateCell" },
        { column: "Histórico", rowName: "historyAction", width: "12%" },
        { column: "Especialidade", rowName: "specialty" },
      ];

  // Paciente: preenche firstDate com a data mais recente (pipeline só tem `date`).
  const tableRows = patientView
    ? (rowData || []).map((row: any) => ({
        ...row,
        firstDate: latestDocDate(row),
        date: latestDocDate(row),
      }))
    : displayRows;

  return (
    <>
      <EhrResponsiveTable
        title="Relatórios e atestados"
        hideSectionHeader
        columns={columns}
        rows={tableRows}
        actions={(row: any) => (
          <CertificateActions
            setRefetch={setRefetch}
            row={row}
            handleOpen={handleOpen}
            setBinaryUrl={setBinaryUrl}
          />
        )}
        renderCard={(row: any) =>
          patientView ? (
            <DocumentCard
              key={row.id ?? row.date}
              title="Relatório médico"
              date={latestDocDate(row)}
              dateLabel="Emitido em"
              practitioner={row.practitioner}
              specialty={row.specialty}
              actions={
                <CertificateActions
                  setRefetch={setRefetch}
                  row={row}
                  handleOpen={handleOpen}
                  setBinaryUrl={setBinaryUrl}
                />
              }
            />
          ) : (
            <DocumentCard
              key={row.id ?? row.date}
              title="Relatório médico"
              date={row.firstDate || row.date}
              dateLabel="Emitido em"
              lastDate={rowHasHistory(row) ? row.lastDate : undefined}
              singleIssue={!rowHasHistory(row)}
              practitioner={row.practitioner}
              specialty={row.specialty}
              actions={
                <CertificateActions
                  setRefetch={setRefetch}
                  row={row}
                  handleOpen={handleOpen}
                  setBinaryUrl={setBinaryUrl}
                />
              }
            >
              {rowHasHistory(row) ? (
                <Button
                  variant="text"
                  color="primary"
                  startIcon={<History />}
                  onClick={() => openHistory(row)}
                  sx={{ textTransform: "none", fontWeight: 600 }}
                >
                  Histórico
                </Button>
              ) : (
                <Chip
                  label="Emissão única"
                  variant="outlined"
                  sx={{
                    fontWeight: 600,
                    color: "text.secondary",
                    borderColor: "divider",
                  }}
                />
              )}
            </DocumentCard>
          )
        }
      />
      {!patientView ? historyDialog : null}
    </>
  );
}
